import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, List, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React, { MouseEventHandler } from "react";
import { StudioData } from "../../Objects/StudioInterface";
import CategoryTitle from "../atoms/CategoryTitle";
import TextFormListItem from "./TextFormListItem";

export interface EditOnlineLessonStudioFormData {
    lstd_id?: number
    std_id?: number
    start_apply?: Date
    end_apply?: Date
    create_at?: Date
    delete_at?: Date
}

export interface EditOnlineLessonStudioFormProps {
    studioDataList: StudioData[]
    editOnlineLessonStudioFormData: EditOnlineLessonStudioFormData
    onChange: (formData: EditOnlineLessonStudioFormData) => void
}

const EditOnlineLessonStudioForm: React.FC<EditOnlineLessonStudioFormProps> = ({
    studioDataList,
    editOnlineLessonStudioFormData,
    onChange,
}) => {

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <FormControl
                        sx={{
                            width: "100%"
                        }}
                        size="small"
                    >
                        <InputLabel id="edit-onlinestudio">適用スタジオ</InputLabel>
                        <Select
                            labelId="edit-onlinestudio"
                            value={editOnlineLessonStudioFormData.std_id ? editOnlineLessonStudioFormData.std_id : 0}
                            onChange={(e: SelectChangeEvent<number>) => {
                                onChange({
                                    ...editOnlineLessonStudioFormData,
                                    std_id: (typeof e.target.value == "string" ? parseInt(e.target.value) : e.target.value)
                                })
                            }}
                            label="適用スタジオ"
                            disabled={editOnlineLessonStudioFormData.lstd_id ? true : false}
                        >
                            <MenuItem value={0} disabled />
                            {studioDataList.map((studioData: StudioData, index: number) => {
                                return <MenuItem value={studioData.std_id} key={index}>{studioData.std_name}{studioData.std_area}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    {/* {studioDataList.map((studioData: StudioData, index: number) => {
                        return <FormControlLabel
                            control={<Checkbox
                                checked={editOnlineLessonStudioFormData.std_ids ? editOnlineLessonStudioFormData.std_ids.includes(studioData.std_id) : false}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    let ids: number[]|undefined = editOnlineLessonStudioFormData.std_ids?.filter( (id: number) => id!==studioData.std_id )
                                    ids = ids ? ids : []
                                    if(e.target.checked) {
                                        ids.push( studioData.std_id )
                                    }
                                   s ids = ids.length > 0 ? ids : undefined
                                    onChange({
                                        ...editOnlineLessonStudioFormData,
                                        std_ids: ids
                                    })
                                }}
                            />}
                            label={studioData.std_name + (studioData.std_area ? `/${studioData.std_area}` : "")}
                            key={index}
                        />
                    })} */}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <DatePicker
                                label="適用開始日"
                                onChange={date => {
                                    onChange({
                                        ...editOnlineLessonStudioFormData,
                                        start_apply: date ? date : undefined
                                    })
                                }}
                                value={editOnlineLessonStudioFormData.start_apply ? editOnlineLessonStudioFormData.start_apply : null}
                                renderInput={params => <TextField {...params} fullWidth size="small" />}
                                inputFormat="yyyy/MM/dd"
                                mask="____/__/__"
                                clearable={true}
                                defaultCalendarMonth={null}
                                disabled={editOnlineLessonStudioFormData.lstd_id ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DatePicker
                                label="適用終了日"
                                onChange={date => {
                                    onChange({
                                        ...editOnlineLessonStudioFormData,
                                        end_apply: date ? date : undefined
                                    })
                                }}
                                value={editOnlineLessonStudioFormData.end_apply ? editOnlineLessonStudioFormData.end_apply : null}
                                renderInput={params => <TextField {...params} fullWidth size="small" />}
                                inputFormat="yyyy/MM/dd"
                                mask="____/__/__"
                                clearable={true}
                                defaultCalendarMonth={null}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}

export default EditOnlineLessonStudioForm